import Vue from "vue";
import WarehouseTransformer from "../../../transformers/catalog/warehouse/warehouse";

export default (opts = {}) => {
  let url = "iwarehouse/";

  if (opts.slug) {
    url += `${opts.slug}/highways/`;
  }

  return Vue.$http.get(url).then(({ data }) => {
    let dataTransformed = null;

    if (opts.slug) {
      dataTransformed = WarehouseTransformer.fetch(data);
    } else {
      dataTransformed = WarehouseTransformer.fetchCollection(data).sort(
        (a, b) => (a.name < b.name ? -1 : 1)
      );
    }

    return dataTransformed;
  });
};



// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/fetchiWarehouse.js